/**
 * "Adresetiket" — één etiket met de naam en het adres van een klant, om op een envelop of een
 * urnverpakking te plakken.
 *
 * <p>Client-side, net als {@code printVoerstickers}: wat je op het scherm ziet is wat er uit de
 * printer komt, en er hoeft geen sjabloon op de server bij te blijven.
 */

export interface AdresetiketOptions {
  naam: string;
  /** De adresregels, al opgemaakt (straat + nummer, postcode + plaats, land). Lege regels vallen weg. */
  regels: (string | null | undefined)[];
  /** Kop van het printvenster. */
  titel: string;
}

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/** Bouwt het etiket als printbare pagina; geeft de html terug zodat een test hem kan nakijken. */
export function adresetiketHtml(opties: AdresetiketOptions): string {
  const regels = opties.regels
    .map((r) => (r ?? "").trim())
    .filter((r) => r !== "")
    .map((r) => `<div class="regel">${esc(r)}</div>`)
    .join("");
  return `<!doctype html>
<html lang="nl">
<head>
<meta charset="utf-8" />
<title>${esc(opties.titel)}</title>
<style>
  @page { size: A4; margin: 15mm; }
  body { font-family: system-ui, "Segoe UI", Arial, sans-serif; color: #25313b; margin: 0; }
  .etiket { display: inline-block; min-width: 90mm; border: 1px dashed #c8d2d9; border-radius: 3mm;
            padding: 8mm 10mm; }
  .naam { font-size: 16pt; font-weight: 800; letter-spacing: -0.01em; margin-bottom: 3mm; }
  .regel { font-size: 13pt; line-height: 1.45; }
</style>
</head>
<body>
  <div class="etiket">
    <div class="naam">${esc(opties.naam)}</div>
    ${regels}
  </div>
</body>
</html>`;
}

/** Zet het etiket in een printvenster. */
export function printAdresetiket(opties: AdresetiketOptions): void {
  const venster = window.open("", "_blank");
  if (!venster) return;
  venster.document.write(adresetiketHtml(opties));
  venster.document.close();
  venster.focus();
  venster.print();
}
